import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const CategoryCard = ({
  data,
  onClick,
  isActive,
  className,
  style,
  v2 = true,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className, {
      [styles.active]: isActive,
      [styles.v2]: v2
    }),
    onClick: () => onClick(),
    style,
    role: "button",
    onKeyDown: (e) => {
      if (e.key === "Enter") {
        onClick();
      }
    },
    tabIndex: 0,
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles["image-wrapper"] }, /* @__PURE__ */ React.createElement("img", { src: data.image, alt: data.title })), /* @__PURE__ */ React.createElement("div", { className: styles.title }, data.title))
);
CategoryCard.displayName = "Wallet.CategoryCard";

export { CategoryCard };
//# sourceMappingURL=index.js.map
